<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">お知らせ（詳細）</div>
      </md-card-header>

      <md-card-content>
        <a href="#" @click="backToList()">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>

        <md-card-content v-if="errorMessages.length">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <flash-message :errors="errorMessages"></flash-message>
            </div>
          </div>
        </md-card-content>
        <loading-spinner v-else-if="loadingSpinner"></loading-spinner>
        <div class="md-layout" v-else>
          <div class="md-layout-item md-size-20 md-small-size-100"></div>
          <div class="md-layout-item md-size-60 md-small-size-100">
            <p class="md-subheading">{{information.information_date}}</p>
            <p class="md-title">{{information.subject}}</p>
            <p class="md-body-1" v-html="information.body"></p>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </main>
</template>

<script>
  import FlashMessage                                   from '../../../components/FlashMessage';
  import CommonMixin                                    from "../../../mixins/commonMixin";
  import LoadingSpinner                                 from '../../../components/LoadingSpinner';
  import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
  import Common                                         from '../../../modules/common';
  import {mapActions}                                   from 'vuex';

  export default {
    name      : "UserNotificationDetail",
    mixins    : [CommonMixin],
    components: {
      FlashMessage,
      LoadingSpinner
    },
    props     : {
      id: String
    },
    data      : () => ({
      information: [],
    }),
    mounted   : function () {
      this.getInformationDetail();
    },
    methods   : {
      ...mapActions('notifications', [
        'saveBack',
      ]),
      backToList() {
        this.saveBack(true);
        this.$router.replace({name: 'BackendUserNotifications'}).then();
      },
      getInformationDetail() {
        this.loadingSpinner = true;
        const detailUrl     = apiList.information.detail.replace(':information_id', this.$props.id);
        apiClient.get(detailUrl)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              this.errorMessages = [this.noDataMessage];
              return;
            }
            if (response.data.information && response.data.information.information_id) {
              this.information      = response.data.information;
              this.information.body = this.information.body.replace(/\n/g, '<br/>');
              this.information.body = Common.replaceUrlToLink(this.information.body);
              return;
            }
            this.errorMessages = [this.noDataMessage];
          })
          .catch(error => {
            this.errorMessages = [this.noDataMessage];
          })
          .finally(() => {
            this.loadingSpinner = false;
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .md-body-1 {
    margin-top: 30px;
    word-break: break-all;
  }
</style>
